import { IntlShape } from 'react-intl'

import { getCancelWithoutSavingModalEvent } from './CancelWithoutSavingModal'
import { OpenModalEvent } from './modalMachine'

export const getCancelEditingPromptModalEvent = ({
  onConfirm,
  onCancel,
  intl,
  header,
  text,
}: {
  onConfirm: () => void
  onCancel?: () => void
  intl: IntlShape
  header?: string
  text?: string
}): OpenModalEvent => {
  return getCancelWithoutSavingModalEvent({
    onConfirm,
    onCancel,
    intl,
    header,
    text:
      text ??
      intl.formatMessage(
        { id: 'common-re-edit-prompt-message' },
        { continue_action: intl.formatMessage({ id: 'common-continue-anyway' }) },
      ),
  })
}
